import React from "react";

export function StatusChip({ status = "normal", children, testid }) {
    const label = children || status;
    return (
        <span className={`kcc-chip ${status}`} data-testid={testid}>
            <span className={`w-1.5 h-1.5 rounded-full bg-current ${status === "critical" ? "kcc-pulse" : ""}`} />
            {label}
        </span>
    );
}

const ACCENT = {
    copper: "kcc-copper-accent",
    cobalt: "kcc-cobalt-accent",
    purple: "kcc-purple-accent",
    green: "kcc-green-accent",
    red: "kcc-red-accent",
    amber: "kcc-amber-accent",
};

export function KpiCard({ kpi, accent = "copper", testid }) {
    const status = kpi.status || "normal";
    const trendUp = kpi.trend === "up";
    const trendDown = kpi.trend === "down";
    return (
        <div className={`kcc-panel ${ACCENT[accent] || ACCENT.copper} p-5 relative overflow-hidden group hover:border-white/20 transition-colors`} data-testid={testid || `kpi-${kpi.key}`}>
            <div className="flex items-start justify-between gap-3">
                <div className="kcc-label">{kpi.label}</div>
                <StatusChip status={status} testid={`kpi-status-${kpi.key}`}>{status}</StatusChip>
            </div>
            <div className="mt-3 flex items-baseline gap-2">
                <div className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-white" data-testid={`kpi-value-${kpi.key}`}>{kpi.value}</div>
                {kpi.unit ? <div className="kcc-text-silver text-xs">{kpi.unit}</div> : null}
            </div>
            {(kpi.delta || kpi.hint) && (
                <div className="mt-2 flex items-center gap-3 text-xs">
                    {kpi.delta && (
                        <span className={trendUp ? "text-kcc-green" : trendDown ? "text-kcc-red" : "kcc-text-silver"}>
                            {trendUp ? "▲" : trendDown ? "▼" : "■"} {kpi.delta}
                        </span>
                    )}
                    {kpi.hint && <span className="kcc-text-dim">{kpi.hint}</span>}
                </div>
            )}
        </div>
    );
}

export function KpiGrid({ kpis, accent = "copper", cols = 4 }) {
    const colClass = { 2: "md:grid-cols-2", 3: "md:grid-cols-3", 4: "md:grid-cols-2 xl:grid-cols-4", 6: "md:grid-cols-3 xl:grid-cols-6" }[cols] || "md:grid-cols-4";
    return (
        <div className={`grid grid-cols-1 ${colClass} gap-4`} data-testid="kpi-grid">
            {(kpis || []).map((k) => <KpiCard key={k.key} kpi={k} accent={accent} />)}
        </div>
    );
}
